import { aboutContent } from '@/config/marketing-content/about'
import { MarketingHero } from '@/components/marketing/marketing-hero'
import { MarketingCta } from '@/components/marketing/marketing-cta'
import { SectionHeader } from '@/components/marketing/section-header'

function AboutContentCard({
  tag,
  title,
  description,
}: {
  tag?: string
  title: string
  description: string
}) {
  return (
    <article className="about-content-card">
      {tag ? (
        <div className="about-content-card__heading">
          <span className="about-content-card__tag">{tag}</span>
          <h3 className="about-content-card__title">{title}</h3>
        </div>
      ) : (
        <h3 className="about-content-card__title about-content-card__title--solo">{title}</h3>
      )}
      <p className="about-content-card__description">{description}</p>
    </article>
  )
}

export function AboutPage() {
  return (
    <main>
      <MarketingHero
        eyebrow={aboutContent.eyebrow}
        title={aboutContent.heroTitle}
        lead={aboutContent.heroLead}
        heroImage={aboutContent.heroImage}
      />

      <section className="marketing-section about-section">
        <div className="marketing-container space-y-10">
          <SectionHeader
            eyebrow={aboutContent.thesisEyebrow}
            title={aboutContent.thesisTitle}
            lead={aboutContent.thesisLead}
            align="center"
          />
          <div className="about-cards-grid about-cards-grid--three">
            {aboutContent.thesisCards.map((card) => (
              <AboutContentCard key={card.title} {...card} />
            ))}
          </div>
        </div>
      </section>

      <section className="marketing-section about-section">
        <div className="marketing-container space-y-10">
          <SectionHeader
            eyebrow={aboutContent.teamEyebrow}
            title={aboutContent.teamTitle}
            lead={aboutContent.teamLead}
            align="center"
          />
          <div className="about-cards-grid about-cards-grid--two">
            {aboutContent.teamCards.map((card) => (
              <AboutContentCard key={card.title} {...card} />
            ))}
          </div>
        </div>
      </section>

      <section className="marketing-section about-section">
        <div className="marketing-container space-y-10">
          <SectionHeader
            eyebrow={aboutContent.notBuildingEyebrow}
            title={aboutContent.notBuildingTitle}
            lead={aboutContent.notBuildingLead}
            align="center"
          />
          <div className="about-cards-grid about-cards-grid--three">
            {aboutContent.notBuildingCards.map((card) => (
              <AboutContentCard key={card.title} {...card} />
            ))}
          </div>
        </div>
      </section>

      <MarketingCta
        title={aboutContent.ctaTitle}
        lead={aboutContent.ctaLead}
        primaryLabel={aboutContent.ctaPrimaryLabel}
        primaryHref={aboutContent.ctaPrimaryHref}
      />

      <div className="marketing-container pb-12">
        <p className="mx-auto max-w-3xl text-center text-xs leading-relaxed text-muted-foreground">
          thinkorswim is not affiliated with Podium Markets Media, LLC (“Podium”).
          Any goods or services offered by Podium are not sponsored, endorsed, sold
          or promoted by thinkorswim, and thinkorswim makes no representation
          regarding any such goods or services.
        </p>
      </div>
    </main>
  )
}
